import { Component, computed, inject } from '@angular/core';
import { UiStore } from '@theme/data-access';

@Component({
  selector: 'lib-live-pickup-theme-switcher',
  templateUrl: './theme-switcher.component.html',
  styleUrl: './theme-switcher.component.scss',
  standalone: true,
})
export class ThemeSwitcherComponent {
  private readonly uiStore = inject(UiStore);

  protected readonly isDark = computed(() => this.uiStore.theme.dark());

  protected onSwitchClick(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    this.uiStore.toggleUiTheme(this.isDark() ? 'light' : 'dark');
  }
}
